import { SEGMENT_MATCH_OP } from './constants';

export function isSegmentOp(op: string) {
  return op === SEGMENT_MATCH_OP;
}
